const DESKTOP_SCREEN_WIDTH = 1280;

export function useReversedOrder() {
  const isReversedOrder = ref(false);

  let resizeController: AbortController | undefined;
  onMounted(() => {
    resizeController = new AbortController();
    isReversedOrder.value = window.innerWidth < DESKTOP_SCREEN_WIDTH;
    window.addEventListener("resize", () => {
      isReversedOrder.value = window.innerWidth < DESKTOP_SCREEN_WIDTH;
    }, { signal: resizeController.signal });
  });

  onUnmounted(() => {
    resizeController?.abort();
  });

  return {
    isReversedOrder,
  };
}